module.exports = __webpack_public_path__ + "img/mainmenbuttonGREEN1.d753ce5d.png";